/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMetiersLocalisationGridDto } from './FcbMetiersLocalisationGridDto';
import {
    FcbMetiersLocalisationGridDtoFromJSON,
    FcbMetiersLocalisationGridDtoFromJSONTyped,
    FcbMetiersLocalisationGridDtoToJSON,
} from './FcbMetiersLocalisationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMetiersLocalisationGridDtoPaginatedResults
 */
export interface FcbMetiersLocalisationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMetiersLocalisationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMetiersLocalisationGridDto>}
     * @memberof FcbMetiersLocalisationGridDtoPaginatedResults
     */
    results?: Array<FcbMetiersLocalisationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMetiersLocalisationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMetiersLocalisationGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMetiersLocalisationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetiersLocalisationGridDtoPaginatedResultsFromJSON(json: any): FcbMetiersLocalisationGridDtoPaginatedResults {
    return FcbMetiersLocalisationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMetiersLocalisationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetiersLocalisationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMetiersLocalisationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMetiersLocalisationGridDtoPaginatedResultsToJSON(value?: FcbMetiersLocalisationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMetiersLocalisationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

